import { MutableRefObject, useEffect, useReducer } from "react";
// 方法
import { formatRowKey, getEffectiveChildren } from "../util";
import { getNumberSortArray } from "../../utils/dataUtils";
// 常量
import { STATUS_CREATED, STATUS_CREATED_CODE, } from '../../constants/constant';
import { IBaseEditVirtualMainTableContext } from "../context/virtualMainTableContext";
import { FormInstance } from "antd/lib/form";
import { ADD_CHILDREN_KEY, ADD_KEY, ALL_CHILDREN_KEY, EditVirtualMainTableDispatchType, EMPTY_CHILDREN_KEY, EMPTY_KEY, IEditVirtualMainTablePayload, MAIN_ROW_KEY, TRAILER_KEY, TRAILER_ROW_KEY, } from "../interface";

export interface IEditVirtualMainTableAction {
  type: EditVirtualMainTableDispatchType;
  payload: IEditVirtualMainTablePayload;
}
export type dispatchFunc = (type: EditVirtualMainTableDispatchType, payload: IEditVirtualMainTablePayload) => void;
/** Action */
function EditVirtualMainTableContextAction(
  state: IBaseEditVirtualMainTableContext,
  action: IEditVirtualMainTableAction,
) {
  const {
    dataSource,
    form,
    addItem,
    appendItem,
    flagIndex,
    updateExpandedRowKeys,
    mainKey,
    childrenKey,
    defaultExpandAllRows,
    showAddSubRow,
    showEmptySubRow,
    changeMainItem,
    changeChildrenItem,
    trailerRow,
  } = action.payload;
  const oldDataSource = (state.tableDataSource ?? []).slice();
  switch (action.type) {
    case 'init':
      const newTableDataSource: any[] = [];
      const newExpandedRowKeys: string[] = [];
      dataSource?.map((item, index) => {
        const itemKey = `${index}`;
        const newChildren: any[] = (item.children ?? []).map?.((child: any, childIndex: number) => ({
          ...child,
          [STATUS_CREATED_CODE]: child[STATUS_CREATED_CODE] ? child[STATUS_CREATED_CODE] : STATUS_CREATED.DEFAULT,
          key: `${index}-${childIndex}`,
        }));
        if (showEmptySubRow && !newChildren.length) {
          newChildren.push({
            [EMPTY_CHILDREN_KEY]: true,
            key: `${index}-${EMPTY_KEY}`,
          });
        }
        showAddSubRow && newChildren.push({
          [ADD_CHILDREN_KEY]: true,
          key: `${index}-${ADD_KEY}`,
        });
        if (trailerRow) {
          getNumberSortArray(trailerRow).forEach(item => {
            newChildren.push({
              [TRAILER_ROW_KEY]: true,
              key: `${index}-${TRAILER_KEY}-${item}`,
            });
          });
        }
        newTableDataSource.push({
          ...item,
          key: itemKey,
          [STATUS_CREATED_CODE]: item[STATUS_CREATED_CODE] ? item[STATUS_CREATED_CODE] : STATUS_CREATED.DEFAULT,
          [MAIN_ROW_KEY]: true,
          children: newChildren,
        });
        newExpandedRowKeys.push(itemKey);
      });
      return {
        ...state,
        form,
        trailerRow,
        expandedRowKeys: defaultExpandAllRows ? newExpandedRowKeys : [],
        tableDataSource: newTableDataSource,
        showAddSubRow,
        showEmptySubRow,
      };
    case 'change':
      return {
        ...state,
        tableDataSource: oldDataSource.map(item => {
          if (item.key === mainKey) {
            return {
              ...item,
              ...changeMainItem,
              [STATUS_CREATED_CODE]:
                item[STATUS_CREATED_CODE] === STATUS_CREATED.ADD
                  ? STATUS_CREATED.ADD
                  : STATUS_CREATED.UPDATE,
              children: item?.children?.map?.((childrenItem: any) => {
                const newChildrenItem: any = {
                  ...childrenItem,
                  [STATUS_CREATED_CODE]:
                    childrenItem[STATUS_CREATED_CODE] === STATUS_CREATED.ADD
                      ? STATUS_CREATED.ADD
                      : STATUS_CREATED.UPDATE,
                };
                if (childrenItem.key === ALL_CHILDREN_KEY) {
                  return {
                    ...newChildrenItem,
                    ...changeChildrenItem,
                  };
                }
                if (childrenItem.key === `${mainKey}-${childrenKey}`) {
                  return {
                    ...newChildrenItem,
                    ...changeChildrenItem,
                  };
                }
                return newChildrenItem;
              }),
            };
          }
          return item;
        }),
      };
    case 'changeData':
      if (Array.isArray(dataSource)) {
        const newChangeDataSource: any[] = [];
        const newChangeExpandedRowKeys: string[] = [];
        dataSource.forEach((item, index) => {
          const itemKey = `${index}`;
          const newChildren: any[] = (item.children ?? []).map?.((child: any, childIndex: number) => ({
            ...child,
            [STATUS_CREATED_CODE]: child[STATUS_CREATED_CODE] ? child[STATUS_CREATED_CODE] : STATUS_CREATED.DEFAULT,
            key: `${index}-${childIndex}`,
          }));
          if (state.showEmptySubRow && !newChildren.length) {
            newChildren.push({
              [EMPTY_CHILDREN_KEY]: true,
              key: `${index}-${EMPTY_KEY}`,
            });
          }
          state.showAddSubRow && newChildren.push({
            [ADD_CHILDREN_KEY]: true,
            key: `${index}-${ADD_KEY}`,
          });
          newChangeDataSource.push({
            ...item,
            key: itemKey,
            [STATUS_CREATED_CODE]: item[STATUS_CREATED_CODE] ? item[STATUS_CREATED_CODE] : STATUS_CREATED.DEFAULT,
            [MAIN_ROW_KEY]: true,
            children: newChildren,
          });
          newChangeExpandedRowKeys.push(itemKey);
        });
        return {
          ...state,
          tableDataSource: newChangeDataSource,
          expandedRowKeys: newChangeExpandedRowKeys,
        };
      }
      return state;
    case 'addExpandedRowKeys':
      if (!updateExpandedRowKeys) return state;
      const newAddExpandedRowKeys: string[] = state.expandedRowKeys?.slice() ?? [];
      if (Array.isArray(updateExpandedRowKeys)) {
        newAddExpandedRowKeys.push(...updateExpandedRowKeys);
      } else {
        newAddExpandedRowKeys.push(updateExpandedRowKeys);
      }
      return {
        ...state,
        expandedRowKeys: newAddExpandedRowKeys,
      };
    case 'deleteExpandedRowKeys':
      if (!updateExpandedRowKeys) return state;
      let newDeleteExpandedRowKeys: string[] = state.expandedRowKeys?.slice() ?? [];
      if (Array.isArray(updateExpandedRowKeys)) {
        newDeleteExpandedRowKeys = newDeleteExpandedRowKeys.filter(v => !updateExpandedRowKeys.includes(v));
      } else {
        newDeleteExpandedRowKeys = newDeleteExpandedRowKeys.filter(v => v !== updateExpandedRowKeys);
      }
      return {
        ...state,
        expandedRowKeys: newDeleteExpandedRowKeys
      };
    case 'addRow':
      let key = flagIndex || 0;
      const newDataSource = oldDataSource;
      const addRowKeys: string[] = [];
      if (Array.isArray(addItem)) {
        addItem.forEach((item, k) => {
          const newChildren: any[] = (item.children ?? []).map?.((child: any, childIndex: number) => ({
            ...child,
            [STATUS_CREATED_CODE]: STATUS_CREATED.ADD,
            key: `${key + k}-${childIndex}`,
          }));
          if (state.showEmptySubRow && !newChildren.length) {
            newChildren.push({
              [EMPTY_CHILDREN_KEY]: true,
              key: `${key + k}-${EMPTY_KEY}`,
            });
          }
          state.showAddSubRow && newChildren.push({
            [ADD_CHILDREN_KEY]: true,
            key: `${key + k}-${ADD_KEY}`,
          });
          newDataSource?.push({
            ...item,
            children: newChildren,
            key:`${key + k}`,
            [STATUS_CREATED_CODE]: STATUS_CREATED.ADD,
            [MAIN_ROW_KEY]: true,
          });
          addRowKeys.push(`${key + k}`);
        });
      } else {
        const newChildren: any[] = (addItem.children ?? []).map?.((child: any, childIndex: number) => ({
          ...child,
          [STATUS_CREATED_CODE]: STATUS_CREATED.ADD,
          key: `${key}-${childIndex}`,
        }));
        if (state.showEmptySubRow && !newChildren.length) {
          newChildren.push({
            [EMPTY_CHILDREN_KEY]: true,
            key: `${key}-${EMPTY_KEY}`,
          });
        }
        state.showAddSubRow && newChildren.push({
          [ADD_CHILDREN_KEY]: true,
          key: `${key}-${ADD_KEY}`,
        });
        newDataSource?.push({
          ...addItem,
          key: `${key}`,
          children: newChildren,
          [STATUS_CREATED_CODE]: STATUS_CREATED.ADD,
          [MAIN_ROW_KEY]: true,
        });
        addRowKeys.push(`${key}`);
      }
      return {
        ...state,
        tableDataSource: newDataSource,
        expandedRowKeys: [...(state.expandedRowKeys ?? []), ...addRowKeys],
      };
    case 'cover':
      let coverKey = flagIndex || 0;
      const newCoverDataSource: any[] = [];
      const addCoverRowKeys: string[] = [];
      oldDataSource.forEach(item => {
        const { children: coverChildren, [STATUS_CREATED_CODE]: recordStatus, ...restItem } = item;
        if (recordStatus === STATUS_CREATED.ADD) return;
        const oldChildren = coverChildren?.filter?.((v: any) => !(v[ADD_CHILDREN_KEY] || v[EMPTY_CHILDREN_KEY]) && v[STATUS_CREATED_CODE] !== STATUS_CREATED.ADD)?.slice();
        newCoverDataSource.push(
          {
            ...restItem,
            [STATUS_CREATED_CODE]: STATUS_CREATED.DELETE,
            children: oldChildren?.map?.((v: any) => ({...v, [STATUS_CREATED_CODE]: STATUS_CREATED.DELETE,}))
          }
        );
      });
      if (Array.isArray(addItem) && addItem.length) {
        addItem.forEach((item, k) => {
          const newChildren: any[] = (item.children ?? []).map?.((child: any, childIndex: number) => ({
            ...child,
            [STATUS_CREATED_CODE]: STATUS_CREATED.ADD,
            key: `${coverKey + k}-${childIndex}`,
          }));
          if (state.showEmptySubRow && !newChildren.length) {
            newChildren.push({
              [EMPTY_CHILDREN_KEY]: true,
              key: `${coverKey + k}-${EMPTY_KEY}`,
            });
          }
          state.showAddSubRow && newChildren.push({
            [ADD_CHILDREN_KEY]: true,
            key: `${coverKey + k}-${ADD_KEY}`,
          });
          newCoverDataSource?.push({
            ...item,
            children: newChildren,
            key:`${coverKey + k}`,
            [STATUS_CREATED_CODE]: STATUS_CREATED.ADD,
            [MAIN_ROW_KEY]: true,
          });
          addCoverRowKeys.push(`${coverKey + k}`);
        });
      }
      return {
        ...state,
        tableDataSource: newCoverDataSource,
        expandedRowKeys: [...(state.expandedRowKeys ?? []), ...addCoverRowKeys],
      };
    case 'append':
      let appendStartKey = flagIndex || 0;
      const newOldDataSource: any[] = [...oldDataSource];
      const newAppendDataSource: any[] = [];
      const addAppendRowKeys: string[] = [];
      if (Array.isArray(appendItem) && appendItem.length) {
        appendItem.forEach(item => {
          const findOldItem = newOldDataSource.find(v => v.key === item.key);
          // 追加的主表行已存在
          if (findOldItem) {
            if (findOldItem[STATUS_CREATED_CODE] === STATUS_CREATED.DELETE) return;
            const oldChildren = findOldItem.children?.filter?.((v: any) => !(v[ADD_CHILDREN_KEY] || v[EMPTY_CHILDREN_KEY]))?.slice();
            const appendChildren = item.children;
            // 该行存在追加的子表行数据
            if (Array.isArray(appendChildren) && appendChildren.length) {
              // 需要追加的子表数据
              const newAppendChildrenItem: any[] = [];
              let currentKey = Number(formatRowKey(oldChildren[oldChildren.length - 1]?.key).childrenKey) | 0;
              appendChildren.forEach((appendChildrenItem: any) => {
                let childrenFindItem = oldChildren.findIndex((oldChildrenItem: any) => oldChildrenItem.key === appendChildrenItem.key);
                // 追加的子表行数据已存在 则在原来数据上修改
                if (childrenFindItem >= 0) {
                  const oldChildrenItem = oldChildren[childrenFindItem];
                  const { mainKey, childrenKey } = formatRowKey(appendChildrenItem.key);
                  const oldStatus = oldChildrenItem[STATUS_CREATED_CODE];
                  const newChildrenItem = {
                    ...appendChildrenItem,
                    [STATUS_CREATED_CODE]: oldStatus === STATUS_CREATED.DEFAULT ? STATUS_CREATED.UPDATE : oldStatus,
                  };
                  if (mainKey && childrenKey) {
                    const rowFormData = form?.getFieldValue([mainKey, childrenKey]);
                    form?.setFieldValue([mainKey, childrenKey], {...rowFormData, ...newChildrenItem})
                  }
                  oldChildren[childrenFindItem] = newChildrenItem;
                } else {
                  // 追加的子表行数据不存在 则保留数据
                  currentKey = currentKey + 1;
                  newAppendChildrenItem.push({
                    ...appendChildrenItem,
                    key: `${findOldItem.key}-${currentKey}`,
                    [STATUS_CREATED_CODE]: STATUS_CREATED.ADD,
                  });
                }
              });
              // 将新的子表数据替换旧的子表数据
              findOldItem[STATUS_CREATED_CODE] = STATUS_CREATED.UPDATE;
              const newChildren = [
                ...oldChildren,
                ...newAppendChildrenItem,
              ];
              // 是否有添加一行
              state.showAddSubRow && newChildren.push({
                [ADD_CHILDREN_KEY]: true,
                key: `${findOldItem.key}-${ADD_KEY}`,
              });
              findOldItem.children = newChildren;
            }
          } else {
            // 追加的主表行不存在
            const { children: appendChildren, ...restItem } = item;
            // 子表数据
            const newAppendChildren: any[] = [];
            // 存在追加的子表数据
            if (Array.isArray(appendChildren) && appendChildren.length) {
              appendChildren.forEach((appendChildrenItem, appendChildrenKey) => {
                newAppendChildren.push({
                  ...appendChildrenItem,
                  [STATUS_CREATED_CODE]: STATUS_CREATED.ADD,
                  key: `${appendStartKey}-${appendChildrenKey}`
                });
              });
            } else {
              // 是否需要标识主表数据为空
              if (state.showEmptySubRow) {
                newAppendChildren.push({
                  [EMPTY_CHILDREN_KEY]: true,
                  key: `${appendStartKey}-${EMPTY_KEY}`,
                });
              }
            }
            // 是否有添加一行
            state.showAddSubRow && newAppendChildren.push({
              [ADD_CHILDREN_KEY]: true,
              key: `${appendStartKey}-${ADD_KEY}`,
            });
            // 主表数据+子表数据
            const appendDataSourceItem: any = {
              ...restItem,
              [MAIN_ROW_KEY]: true,
              [STATUS_CREATED_CODE]: STATUS_CREATED.ADD,
              key: `${appendStartKey}`,
              children: newAppendChildren,
            };
            addAppendRowKeys.push(`${appendStartKey}`);
            newAppendDataSource.push(appendDataSourceItem);
            appendStartKey = appendStartKey + 1;
          }
        });
        return {
          ...state,
          tableDataSource: [ ...newOldDataSource, ...newAppendDataSource,],
          expandedRowKeys: [...(state.expandedRowKeys ?? []), ...addAppendRowKeys],
        };
      }
      return state;
    case 'addChildren':
      if (!mainKey) return state;
      const newAddDataSource: any[] = [];
      oldDataSource.forEach(item => {
        if (item.key === mainKey) {
          const newChildren: any[] = state.showEmptySubRow ? item.children?.filter?.((v: any) => !v.key.includes(EMPTY_KEY)) : item.children;
          const rowChildrens: any[] = state.showAddSubRow ? newChildren.slice(0, -1) : newChildren;
          const otherChildrens: any[] = state.showAddSubRow ?  newChildren.slice(-1) : [];
          const currentKey = (Number(formatRowKey(rowChildrens[rowChildrens.length - 1]?.key).childrenKey) | 0) + 1;
          if (Array.isArray(addItem)) {
            addItem.forEach((child, key) => {
              rowChildrens.push({
                ...child,
                [STATUS_CREATED_CODE]: STATUS_CREATED.ADD,
                key: `${mainKey}-${currentKey + key}`,
              });
            });
          } else {
            rowChildrens.push({
              ...addItem,
              [STATUS_CREATED_CODE]: STATUS_CREATED.ADD,
              key: `${mainKey}-${currentKey}`,
            });
          }
          newAddDataSource.push({
            ...item,
            [STATUS_CREATED_CODE]: item[STATUS_CREATED_CODE] === STATUS_CREATED.ADD ? STATUS_CREATED.ADD : STATUS_CREATED.UPDATE,
            children: [...rowChildrens, ...otherChildrens],
          });
          return;
        }
        newAddDataSource.push(item);
      });
      return {
        ...state,
        tableDataSource: newAddDataSource,
      };
    case 'deleteRow':
      let deleteRowData = oldDataSource.find(v => v.key === mainKey);
      if (deleteRowData) {
        const surplusRowData = oldDataSource.filter(v => v.key !== mainKey);
        if (deleteRowData[STATUS_CREATED_CODE] === STATUS_CREATED.ADD) {
          return {
            ...state,
            tableDataSource: surplusRowData,
          };
        }
        const newChildren: any[] = (deleteRowData.children ?? []).filter?.((v: any) => v[STATUS_CREATED_CODE] !== STATUS_CREATED.ADD).map?.((v: any) => ({
          ...v,
          [STATUS_CREATED_CODE]: STATUS_CREATED.DELETE,
        }));
        if (state.showEmptySubRow && !newChildren.length) {
          newChildren.push({
            [EMPTY_CHILDREN_KEY]: true,
            key: `${mainKey}-${EMPTY_KEY}`,
          });
        }
        deleteRowData = {
          ...deleteRowData,
          [STATUS_CREATED_CODE]: STATUS_CREATED.DELETE,
          children: newChildren,
        };
        return {
          ...state,
          tableDataSource: [
            deleteRowData,
            ...surplusRowData,
          ],
        };
      }
      return state;
    case 'deleteChildren':
      if (!mainKey || !childrenKey) return state;
      const newDelateDataSource: any[] = [];
      oldDataSource.forEach(item => {
        if (item.key === mainKey) {
          const findChildren = item.children?.find?.((v: any) => v.key === childrenKey);
          const surplusRowChildren = item.children?.filter?.((v: any) => v.key !== childrenKey);
          if (findChildren && findChildren[STATUS_CREATED_CODE] !== STATUS_CREATED.ADD) {
            findChildren[STATUS_CREATED_CODE] = STATUS_CREATED.DELETE;
            surplusRowChildren?.unshift?.(findChildren);
          }
          if (state.showEmptySubRow) {
            const effectiveChildren = getEffectiveChildren(surplusRowChildren).filter((v: any) => v[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE);
            if (!effectiveChildren.length) {
              surplusRowChildren.unshift({
                [EMPTY_CHILDREN_KEY]: true,
                key: `${mainKey}-${EMPTY_KEY}`,
              });
            }
          }
          newDelateDataSource.push({
            ...item,
            [STATUS_CREATED_CODE]: item[STATUS_CREATED_CODE] === STATUS_CREATED.ADD ? STATUS_CREATED.ADD : STATUS_CREATED.UPDATE,
            children: surplusRowChildren,
          });
          return;
        }
        newDelateDataSource.push(item);
      });
      return {
        ...state,
        tableDataSource: newDelateDataSource,
      };
    case 'emptyRow':
      if (!mainKey) return state;
      const newEmptyDataSource: any[] = [];
      oldDataSource.forEach(item => {
        if (item.key === mainKey) {
          const newChildren: any[] = getEffectiveChildren(item.children).filter((v: any) => v[STATUS_CREATED_CODE] !== STATUS_CREATED.ADD)?.map((v: any) => {
            return {
              ...v,
              [STATUS_CREATED_CODE]: STATUS_CREATED.DELETE,
            };
          });
          const isEmpty = newChildren.find(v => !!v?.[EMPTY_CHILDREN_KEY]);
          state.showEmptySubRow && !isEmpty && newChildren.push({
            [EMPTY_CHILDREN_KEY]: true,
            key: `${mainKey}-${EMPTY_KEY}`,
          });
          const isAdd = newChildren.find(v => !!v?.[ADD_CHILDREN_KEY]);
          state.showAddSubRow && !isAdd && newChildren.push({
            [ADD_CHILDREN_KEY]: true,
            key: `${mainKey}-${ADD_KEY}`,
          });
          newEmptyDataSource.push({
            ...item,
            [STATUS_CREATED_CODE]: item[STATUS_CREATED_CODE] === STATUS_CREATED.ADD ? STATUS_CREATED.ADD : STATUS_CREATED.UPDATE,
            children: newChildren,
          });
          return;
        }
        newEmptyDataSource.push(item);
      });
      return {
        ...state,
        tableDataSource: newEmptyDataSource,
      };
    case 'empty':
      const effectiveDataSource: any[] = [];
      oldDataSource.forEach(item => {
        if (item[STATUS_CREATED_CODE] !== STATUS_CREATED.ADD) {
          effectiveDataSource.push({
            ...item,
            [STATUS_CREATED_CODE]: STATUS_CREATED.DELETE,
            children: item.children?.filter?.((v: any) => v[STATUS_CREATED_CODE] !== STATUS_CREATED.ADD)?.map((v: any) => ({
              ...v,
              [STATUS_CREATED_CODE]: STATUS_CREATED.DELETE,
            }))
          });
        }
      });
      return {
        ...state,
        tableDataSource: effectiveDataSource,
        expandedRowKeys: [],
      };
    default:
      return state;
  }
}

/** 初始数据 */
const initEditVirtualMainTableContext: IBaseEditVirtualMainTableContext = {};

function useEditVirtualMainTableContext(
  flagIndex: MutableRefObject<number>,
  dataSource?: any[],
  form?: FormInstance,
  defaultExpandAllRows?: boolean,
  showAddSubRow?: boolean,
  showEmptySubRow?: boolean,
  trailerRow?: number,
) {
  const [state, dispatch] = useReducer(
    EditVirtualMainTableContextAction,
    initEditVirtualMainTableContext,
  );
  useEffect(() => {
    flagIndex.current = dataSource?.length || 0;
    dispatch({ type: 'init', payload: { dataSource, form, defaultExpandAllRows, showAddSubRow, showEmptySubRow, trailerRow, } });
  }, [dataSource]);
  function dispatchEditVirtualMainTable(
    type: EditVirtualMainTableDispatchType,
    payload: IEditVirtualMainTablePayload = {},
  ) {
    const { addItem, appendItem, } = payload;
    switch (type) {
      case 'addRow':
        const num = flagIndex.current;
        flagIndex.current = Array.isArray(addItem)
          ? num + addItem.length
          : num + 1;
        dispatch({ type, payload: { addItem, flagIndex: num } });
        break;
      case 'cover':
        const coverNum = flagIndex.current;
        flagIndex.current = Array.isArray(addItem)
          ? coverNum + addItem.length
          : coverNum + 1;
        dispatch({ type, payload: { addItem, flagIndex: coverNum } });
        break;
      case 'append':
        if (Array.isArray(appendItem) && appendItem.length) {
          const appendNum = flagIndex.current;
          flagIndex.current = Array.isArray(appendItem)
            ? appendNum + appendItem.length
            : appendNum + 1;
          dispatch({ type, payload: { appendItem, flagIndex: appendNum } });
        }
        break;
      default:
        dispatch({ type, payload, });
        break;
    }
  }
  return {
    ...state,
    dispatchEditVirtualMainTable,
  };
}

export default useEditVirtualMainTableContext;